import {
  FaAddressBook,
  FaAnglesUp,
  FaAngleUp,
  FaBlackTie,
  FaBook,
  FaBullseye,
  FaCakeCandles,
  FaCalendarCheck,
  FaCashRegister,
  FaChartBar,
  FaChartSimple,
  FaCircleLeft,
  FaCodePullRequest,
  FaCreditCard,
  FaDatabase,
  FaDisplay,
  FaDollarSign,
  FaFaceSmile,
  FaGears,
  FaGift,
  FaGroupArrowsRotate,
  FaHouse,
  FaLayerGroup,
  FaPercent,
  FaPlaneDeparture,
  FaReceipt,
  FaSackDollar,
  FaSquareCheck,
  FaTags,
  FaTicketSimple,
  FaWarehouse,
} from "react-icons/fa6";

const MenuFinance = [
  {
    label: "Home",
    to: "",
    icon: <FaHouse />,
  },
  {
    label: "Transaction",
    type: "menu-title",
  },
  {
    label: "Sales",
    to: "transaction/sales",
    icon: <FaReceipt />,
  },
  {
    label: "Sales Journal",
    to: "transaction/salesjournal",
    icon: <FaBook />,
  },
  {
    label: "Appointment",
    to: "transaction/appointment",
    icon: <FaCalendarCheck />,
  },
  {
    label: "Customer Data",
    to: "transaction/customerdata",
    icon: <FaFaceSmile />,
  },
  {
    label: "Price List",
    to: "transaction/price-list",
    icon: <FaDollarSign />,
  },
  {
    label: "Birthday",
    to: "transaction/birthday",
    icon: <FaCakeCandles />,
  },
  {
    label: "Follow Up",
    to: "transaction/follow-up",
    icon: <FaSquareCheck />,
  },
  {
    label: "Attendance",
    to: "employee/attendance",
    icon: <FaAddressBook />,
  },
  {
    label: "Vacation",
    to: "employee/vacation",
    icon: <FaPlaneDeparture />,
  },
  {
    label: "Customer",
    type: "menu-title",
  },
  {
    label: "Request Expired Date",
    to: "customer/request-expired-date",
    icon: <FaAnglesUp />,
  },
  {
    label: "Package Request",
    to: "customer/package-request",
    icon: <FaCodePullRequest />,
  },
  {
    label: "Customer Voucher",
    to: "customer/vouchers",
    icon: <FaTicketSimple />,
  },
  {
    label: "Customer Discount",
    to: "customer/discounts",
    icon: <FaPercent />,
  },
  {
    label: "Stock",
    type: "menu-title",
  },
  {
    label: "Stock In",
    to: "stock/stockin",
    icon: <FaCircleLeft />,
  },
  {
    label: "Stock Balance",
    to: "stock/stockbalance",
    icon: <FaChartSimple />,
  },
  {
    label: "Stock Movement",
    to: "stock/stockmovement",
    icon: <FaChartSimple />,
  },
  {
    label: "Report",
    type: "menu-title",
  },
  {
    label: "Report",
    to: "report",
    icon: <FaChartBar />,
  },
  {
    label: "Report Voucher",
    to: "report/customer-voucher",
    icon: <FaTicketSimple />,
  },
  {
    label: "Report Discount",
    to: "report/customer-discount",
    icon: <FaPercent />,
  },
  {
    label: "Report Free Product",
    to: "report/customer-free-product",
    icon: <FaGift />,
  },
  {
    label: "Report Point",
    to: "report/customer-point",
    icon: <FaChartSimple />,
  },
  {
    label: "Master & Setting",
    type: "menu-title",
  },
  {
    label: "Master Transaksi",
    icon: <FaDatabase />,
    type: "menu-group",
    children: [
      {
        label: "Branch",
        to: "master/branch",
        icon: <FaBlackTie />,
      },
      {
        label: "Warehouse",
        to: "master/warehouse",
        icon: <FaWarehouse />,
      },
      {
        label: "Product Category",
        to: "master/productcategory",
        icon: <FaGroupArrowsRotate />,
      },
      {
        label: "Product Display",
        to: "master/productdisplay",
        icon: <FaDisplay />,
      },
      {
        label: "Product",
        to: "master/product",
        icon: <FaTags />,
      },
      {
        label: "Payment",
        to: "master/payment",
        icon: <FaCashRegister />,
      },
      {
        label: "Voucher",
        to: "master/voucher",
        icon: <FaCreditCard />,
      },
      {
        label: "Expense Group",
        to: "master/expensegroup",
        icon: <FaLayerGroup />,
      },
      {
        label: "Expense",
        to: "master/expense",
        icon: <FaSackDollar />,
      },
      {
        label: "Target",
        to: "master/target",
        icon: <FaBullseye />,
      },
      {
        label: "Discount",
        to: "master/discount",
        icon: <FaTags />,
      },
    ],
  },
  {
    label: "Setting",
    icon: <FaGears />,
    to: "setting/general",
    children: [],
  },
];

export default MenuFinance;
